<div class="w-100">
	<div class="mx-auto x-small">Focus CA • 48 Waterworks Irvine CA 92618 • <a href="https://focusca.com" target="_blank">focusca.com</a></div>
	<div class="mx-auto x-small">
		This quote and its related materials are property of Focus POS of Arizona, LLC and shall not be distributed without express consent of Focus.
	</div>
</div>
